export const copyingFlowProject = 'copyingFlowProject';
